module.exports = __webpack_public_path__ + "static/img/school_banner_h5.da1cb62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/school_banner_h5.png
// module id = r1R0
// module chunks = 34